/**
 * normalizeUser
 *
 * バックエンドは SaaSUser を返す際に `full_name` キーを使う場合がある。
 * フロントの SaaSUser 型は `name` を期待するため、このユーティリティで差異を吸収する。
 *
 * 変換ルール: name = raw.name ?? raw.full_name ?? ''
 * - raw.name が存在する（undefined でない）場合はそのまま使う
 * - raw.name が undefined で raw.full_name がある場合は full_name を使う
 * - 両方 undefined の場合は空文字
 *
 * バックエンドの API 契約（full_name キー）は変えず、フロント側で吸収する方針。
 */

import type { SaaSUser } from '@/types'

/**
 * バックエンドレスポンスに含まれる可能性のある追加フィールド。
 * name を optional にしているのは、バックエンドが name を返さず
 * full_name のみを返すケースを吸収するため。
 * 戻り値型 SaaSUser では name は required のまま維持する。
 */
type RawUserResponse = Omit<SaaSUser, 'name'> & {
  name?: string
  full_name?: string
}

/**
 * バックエンドの生ユーザーオブジェクトを SaaSUser に正規化する。
 * OAuth・email ログイン両経路で呼び出す。
 */
export function normalizeUser(raw: RawUserResponse): SaaSUser {
  return {
    ...raw,
    name: raw.name ?? raw.full_name ?? '',
  }
}
